import React from 'react';
import Button, {BUTTON_ICON_POSITION} from '../common/Button';
import useCurrentConcept from "../hooks/useCurrentConcept";
import {ChevronRightIcon, ChevronLeftIcon} from '../common/icons/';

const PreviousNextLessonDevelopment= () => {
    const { loadPreviousConcept, loadNextConcept } = useCurrentConcept();

    const handleLoadPreviousConcept = () => {
        loadPreviousConcept(localStorage.getItem("conceptId"));
    };

    const handleLoadNextConcept = () => {
        loadNextConcept(localStorage.getItem("conceptId"));
    };

    return(
        <div className='ch-lesson-navigation-wrapper'>
            <div className='ch-lesson-navigation'>
                <Button
                    onClick={handleLoadPreviousConcept}
                    type={'text'}
                    icon={<ChevronLeftIcon />}
                >
                     Previous Lesson
                </Button>
                <Button
                    onClick={handleLoadNextConcept}
                    type={'text'}
                    icon={<ChevronRightIcon />}
                    iconPosition={BUTTON_ICON_POSITION.RIGHT}
                >
                    Next Lesson
                </Button>
            </div>
        </div>
    )
};

export default PreviousNextLessonDevelopment;